module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/browserify-sign/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = xXuq
// module chunks = 1